import React from 'react';
export function StickyBar() {
  return <div className="fixed top-0 left-0 right-0 bg-gold text-dark font-medium text-xs md:text-sm py-2 px-4 text-center z-50 shadow-md" data-id="element-236">
      Descarga inmediata • Pago único de $16 • Sin suscripciones • Sin trucos
    </div>;
}